// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"189":"5093c15d","296":"c1c76582"}[chunkId] + ".chunk.js");